<h2 mat-dialog-title class="tt-secondary-background" cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragBoundary=".cdk-overlay-container" cdkDragHandle style="color: white">
    <span class="far fa-stars" style="margin-right: 4px"></span>
    <span ttTranslateWord="favourites"></span>
</h2>

<mat-dialog-content style="display: flex; flex-direction: column">
    <tt-toast [hidden]="!errorMessage" ttType="warning" [ttTitle]="errorMessage" ttTranslateTitle="false" style="margin-top: 7px; float: left"></tt-toast>
    <div style="display: flex; flex-direction: column-reverse">
        <div class="tt-favourites__input-group">
            <span class="tt-favourites__input-group--icon fa-fw far fa-search"></span>
            <input class="tt-favourites__input" [(ngModel)]="filter" />
        </div>
        <tt-input *ngIf="!current" ttLabel="add_new_favourite" ttLabelView="top" [(ttModel)]="name" [ttPlaceholder]="(navBar.heading$ | async) ?? ''">
            <ng-container buttons>
                <tt-form-field-button [ttIcon]="saving ? 'fas fa-spinner-third' : 'fas fa-plus'" ttType="success" (ttClick)="save()" [ttDisabled]="saving"></tt-form-field-button>
            </ng-container>
        </tt-input>
        <tt-input *ngIf="!!current" ttLabel="edit_name" ttLabelView="top" [(ttModel)]="name" [ttPlaceholder]="(navBar.heading$ | async) ?? ''">
            <ng-container buttons>
                <tt-form-field-button [ttIcon]="saving ? 'fas fa-spinner-third' : 'fas fa-save'" ttType="success" (ttClick)="update()" [ttDisabled]="saving"></tt-form-field-button>
            </ng-container>
        </tt-input>
    </div>
    <tt-list style="flex: 1; overflow: auto">
        <tt-list-item
            *ngFor="let favourite of favourites | listFilter : filter"
            [ttRadioSelection]="favourite.item_state + favourite.item_parms === state + parms"
            [ttRadioChecked]="state + parms"
            [ttId]="favourite.item_state + favourite.item_parms"
            [ttTitle]="favourite.item_name"
            [ttGoto]="favourite.item_state"
            [ttGotoParms]="favourite.item_parms"
        >
            <ng-container buttons>
                <tt-form-field-button
                    [hidden]="favourite.toDelete === true"
                    ttIcon="fas fa-trash"
                    ttType="danger"
                    ttTooltip="delete"
                    [ttTranslateTooltip]="true"
                    (ttClick)="setToDelete(favourite, true)"
                ></tt-form-field-button>
                <tt-form-field-button
                    [hidden]="favourite.toDelete !== true"
                    ttIcon="fas fa-trash-undo"
                    ttType="success"
                    ttTooltip="undo_delete"
                    [ttTranslateTooltip]="true"
                    (ttClick)="setToDelete(favourite, false)"
                ></tt-form-field-button>
            </ng-container>
        </tt-list-item>
    </tt-list>
</mat-dialog-content>
